import * as React from "react"
import { IconButton } from "@chakra-ui/react"
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi"
import { SDKContext } from "../../../../context/SDKContext"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { StyledMuteIcon } from "../../buttons-main-screen/buttons-main-screen.styled"
import { usersSelector, userIdsSelector } from "../../../../recoil/atoms/users"
import { IconButton as CustomIconButton } from "../../../common/buttons"
import { viewDependingLayoutAtom } from "../../../../recoil/atoms/view"
import { ConsoleLogger } from "../../../../util/logger"

const logger = new ConsoleLogger()

interface MuteUserButtonProps {
  uid: string
  isMainScreen: boolean
  changeSizeIconDependingHeightVideo?: (
    minHeightIcon: number,
    maxHeightIcon: number
  ) => number
}

export const MuteUserButton: React.FC<MuteUserButtonProps> = ({
  uid,
  isMainScreen,
  changeSizeIconDependingHeightVideo
}) => {
  const meetingClient = React.useContext(SDKContext)
  /* const [isMute, setMute] = React.useState(false) */
  const user = useRecoilValue(usersSelector(uid))
  const setUsers = useSetRecoilState(userIdsSelector)
  const { isLandscape } = useRecoilValue(viewDependingLayoutAtom)
  const roomStyles = useRecoilValue(brandingSelector)

  /* React.useEffect(() => {
    if (uid) {
      const { audioTrack } = meetingClient.getMediaTracks(uid)
      setMute(audioTrack?.isPlaying)
    }
  }, [uid]) */

  const muteCurrentUser = () => {
    try {
      const { audioTrack } = meetingClient.getMediaTracks(uid)

      if (audioTrack) {
        audioTrack.stop()
      }

      /* MeetOnline?.client().rtc?.muteCurrentUser(uid) */
      setUsers({
        name: "UPDATE",
        userId: uid,
        attributes: { muted: true }
      })
    } catch (err) {
      logger.error("Error: muteCurrentUser - ", err)
    }
  }

  const unmuteCurrentUser = () => {
    const { audioTrack } = meetingClient.getMediaTracks(uid)

    if (audioTrack) {
      audioTrack.play()
    }

    /*  MeetOnline?.client().rtc?.unmuteCurrentUser(uid) */
    setUsers({
      name: "UPDATE",
      userId: uid,
      attributes: { muted: false }
    })
  }

  return (
    <>
      {isMainScreen ? (
        <CustomIconButton
          width={"1.9rem"}
          height={
            isLandscape
              ? "2.1rem"
              : `${changeSizeIconDependingHeightVideo(30, 40)}px`
          }
          onClick={user?.muted ? unmuteCurrentUser : muteCurrentUser}
        >
          <StyledMuteIcon
            /* onTouchStart={user?.muted ? unmuteCurrentUser : muteCurrentUser} */
            roomStyles={roomStyles}
            as={user?.muted ? HiVolumeOff : HiVolumeUp}
          />
        </CustomIconButton>
      ) : (
        <IconButton
          aria-label="mute-icon"
          onTouchStart={user?.muted ? unmuteCurrentUser : muteCurrentUser}
          icon={user?.muted ? <HiVolumeOff /> : <HiVolumeUp />}
          background={roomStyles.joinButtonBackgroundColor}
          color={roomStyles.joinPageButtonTextColor}
          borderRadius="50%"
          width="35px"
          height="35px"
          minW="35px"
          minH="35px"
          _focus={{}}
          _hover={{}}
          _active={{}}
        />
      )}
    </>
  )
}
